import React, { memo } from 'react'

function Required({ label, required }) {
    return (
        <>
            {label}
            {required && <span> (<span className="text-required">*</span>)</span>}
        </>
    )
}

export default memo(Required)